import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  ButtonProps,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';

import { UndoneButtonProps } from './types';

export const UndoneButton = ({
  onConfirm,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Confirm',
  confirmTitle = 'Confirm Action',
  confirmMessage = 'Are you sure you want to undo this action? This cannot be reversed.',
  ...props
}: UndoneButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleClick: ButtonProps['onClick'] = (e) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setOpen(false);
  };

  return (
    <>
      <Button onClick={handleClick} {...props} />

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{confirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText>{confirmMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleClose}>
            {cancelButtonText}
          </Button>
          <Button color="warning" variant="contained" onClick={handleConfirm}>
            {confirmButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
